/*
 * Code generated by maegi. DO NOT EDIT.
 */

import type React from "react";

export const Check10 = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={10} height={8} viewBox="0 0 10 8" {...props}>
    <path fill="currentColor" d="M3.58 5.574 8.854 0 10 1.213 3.58 8 0 4.214l1.147-1.212z" />
  </svg>
);

export const Check16 = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={16} height={16} viewBox="0 0 16 16" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m6.013 9.806 7.381-7.583L15 3.873l-8.987 9.233L1 7.956l1.606-1.65z"
    />
  </svg>
);

export const __descriptor_Check = {
  name: "Check",
  instances: [
    { size: 10, Component: Check10 },
    { size: 16, Component: Check16 },
  ],
} as const;
